import { twc } from 'react-twc';

const SmallChip = twc.span`py-1 px-3.5 text-xs sm:text-lg font-medium bg-gray-7 rounded-full`;

export default SmallChip;
